import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL

// ─── Interfaces ───────────────────────────────────────────────────────────────

export interface CostCenter {
  cost_center_id: number
  company_id: number
  center_code: string
  center_name: string
  department: string
  department_head: string
  total_budget: number
  status: string
  description: string
}

// ─── Cost Center APIs ─────────────────────────────────────────────────────────

export const getCostCenters = async (companyId: string): Promise<CostCenter[] | undefined> => {
  return await axios
    .get(`${API_URL}/cost-center/${companyId}/list`)
    .then((response: AxiosResponse<CostCenter[]>) => response.data)
    .then((response: CostCenter[]) => response)
}

export const createCostCenter = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.post(`${API_URL}/cost-center/`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const deleteCostCenter = async (
  companyId: string,
  costCenterId: number
): Promise<{detail: string} | undefined> => {
  return await axios
    .delete(`${API_URL}/cost-center/${companyId}/${costCenterId}`)
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}
